module.exports = __webpack_public_path__ + "static/Neubau_Hotel-375c827c20f048c4cc9ea8212775839b.png";